import React from 'react';
import { useTranslation } from 'react-i18next';

const statusTone = {
  OPEN: 'open',
  IN_PROGRESS: 'in-progress',
  CLOSED: 'closed',
  PENDING_APPROVAL: 'approval',
  PARTIALLY_APPROVED: 'approval',
  APPROVED: 'approval',
  DISAPPROVED: 'terminal',
  CANCELLED: 'terminal',
};

export const getActionItemStatusTone = (status) => (
  statusTone[status] || 'terminal'
);

const ActionItemStatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const tone = getActionItemStatusTone(status);

  return (
    <span className={`action-item-status action-item-status--${tone}`}>
      {t(`actionItems.status.${status}`)}
    </span>
  );
};

export default ActionItemStatusBadge;
